import { calcularDerivados } from "../domain";
import type { Oferta } from "../types";
import { EscadaMini } from "./EscadaMini";
import { TendenciaLabel } from "./Tendencia";

/**
 * Indicador compacto de evolução para linhas de lista: mini-escada (passo máximo
 * atingido) + contagem de exposições + tendência. Permite "bater o olho e ver
 * que está melhorando" — o coração do valor do app (P0.4).
 */
export function IndicadorEvolucao({
  alimentoId,
  ofertas,
}: {
  alimentoId: string;
  ofertas: Oferta[];
}) {
  const d = calcularDerivados(alimentoId, ofertas);

  if (d.n_ofertas === 0) {
    return <div className="evol evol-vazio">ainda não oferecido</div>;
  }

  return (
    <div className="evol">
      <EscadaMini passo={d.passo_maximo} />
      <span className="evol-meta">
        {d.n_ofertas} {d.n_ofertas === 1 ? "oferta" : "ofertas"}
      </span>
      {d.tendencia !== "poucos_dados" && <TendenciaLabel tendencia={d.tendencia} />}
    </div>
  );
}
